import { Avatar, Chip as ChipMui, Stack, styled, Typography } from '@mui/material';
import { neutral, pacific } from 'theme/colors';
import { Analytic } from 'types/analytic';

interface IAgentProps {
  index: number;
  agent: Analytic;
}

const TaskCountSpan = styled('span')<{ isColored?: boolean }>`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 96%;
  color: ${({ isColored }) => (isColored ? pacific.main : 'inherit')};
`;

const Chip = styled(ChipMui)<{ isColored?: boolean }>`
  color: ${({ isColored }) => (isColored ? pacific.main : neutral[900])};
  border-radius: 12px;
  background: ${({ isColored }) => (isColored ? pacific.alpha4 : 'rgba(17, 25, 39, 0.04)')};

  & .MuiChip-label {
    font-size: 13px;
    font-weight: 500;
    opacity: 0.5;
    font-family: Inter, sans-serif;
  }
`;

export const Agent = ({ agent, index }: IAgentProps) => {
  // eslint-disable-next-line camelcase
  const { name, tasks_completed } = agent;
  const [firstName, lastName] = name.split(' ');

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
      >
        <Avatar
          sx={{
            backgroundColor: index ? pacific.alpha20 : pacific.main,
            color: index ? pacific.main : 'white',
          }}
        >
          {firstName[0]}
          {lastName?.[0]}
        </Avatar>
        <Typography
          variant="body1"
          sx={{
            color: !index && pacific.main,
          }}
        >
          {name}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
      >
        <Chip
          label={`#${index + 1}`}
          variant="filled"
          isColored={!index}
        />
        <Stack gap={1}>
          <Typography
            variant="body2"
            sx={{
              color: neutral[900],
              opacity: 0.5,
              fontWeight: 600,
            }}
          >
            Tasks Completed
          </Typography>
          {/* eslint-disable-next-line camelcase */}
          <TaskCountSpan isColored={!index}>{tasks_completed}</TaskCountSpan>
        </Stack>
      </Stack>
    </Stack>
  );
};
